import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#1D1D1D\" clip-path=\"url(#i1117903311__a)\"><path d=\"M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm0 10.88A4.88 4.88 0 1 1 12.88 8c0 2.7-2.18 4.88-4.88 4.88Z\"></path><path d=\"M7.44 4.81V8c0 .19.09.36.25.47l2.25 1.5c.25.18.6.12.79-.13.19-.25.12-.6-.13-.79-.01 0-.02-.02-.04-.02l-2-1.33V4.81a.565.565 0 0 0-1.13 0h.01Z\"></path></g><defs><clipPath id=\"i1117903311__a\"><path fill=\"#fff\" d=\"M2 2h12v12H2z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clock-icon"}) } }